import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { TTS } from 'pricing-pages-lib/constants/CtaTypes';
import { getHubsSignupUrl, getTtsUrl } from 'pricing-pages-lib/utils/publicPageUrls';
import { getSavedQueryParamString } from 'pricing-pages-lib/utils/queryParamUtils';
import { productForSkuIdSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { hubsSignupCTASelector } from 'pricing-pages-ui/selectors/TrackingSelectors';
import partial from 'transmute/partial';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useTrackingFlow } from '../../../hooks/useTrackingFlow';
import { useAppSelector } from '../../../reducers';
import { isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { trackTalkToSalesClick } from '../../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const TalkToSalesButton = props => {
  const {
    sourceId,
    skuId,
    use = 'primary',
    nonMerchandiseIdProduct,
    hubsSignupProductOverride,
    size,
    productIdentifier,
    trackingSource,
    productConfigurations,
    onClick: passthroughOnClick
  } = props;
  const isAppReady = useGlobalLoading();
  const hubsSignupCta = useAppSelector(state => hubsSignupCTASelector(state, {
    pathname: window.location.pathname,
    skuId,
    ctaType: TTS,
    sourceId,
    nonMerchandiseIdProduct: hubsSignupProductOverride || nonMerchandiseIdProduct,
    isAppReady
  }));
  const hubsSignupUrl = getHubsSignupUrl({
    nonMerchandiseIdProduct: hubsSignupProductOverride || nonMerchandiseIdProduct
  });
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const apiName = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }).apiName);
  const apiNames = useAppSelector(state => {
    return (productConfigurations === null || productConfigurations === void 0 ? void 0 : productConfigurations.map(productConfig => {
      return productForSkuIdSelector(state, {
        skuId: productConfig.skuId
      }).apiName;
    })) || [];
  });
  const hubsParamString = getSavedQueryParamString() && `&${getSavedQueryParamString()}`;
  const HREF = `${getTtsUrl()}?hubs_signup-url=${hubsSignupUrl}&hubs_signup-cta=${hubsSignupCta}${hubsParamString}&hsSeats=${isUngatedForSeats}`;
  const flow = useTrackingFlow({
    productConfigurations: productConfigurations || [],
    purchaseMotion: 'TALK_TO_SALES'
  });
  const onClick = e => {
    passthroughOnClick === null || passthroughOnClick === void 0 || passthroughOnClick(e);
    trackTalkToSalesClick({
      trackingSource,
      skuId,
      productName: apiName,
      productNames: apiNames,
      nonMerchandiseIdProduct,
      hubsSignupCta,
      hubsSignupUrl,
      flow
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    use: use,
    href: HREF,
    target: "_blank",
    "data-selenium-id": `${trackingSource}-${productIdentifier}-TALK_TO_SALES-button`,
    onClick: partial(onClick),
    size: size,
    block: true,
    margin: "0",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pricingCtas.talkToSales"
    })
  });
};
export default TalkToSalesButton;